<div class="filter filter-property full-span" [class.disabled]="!filter.showVendoringRares">
  <span class="input-group-btn">
    <button class="btn toggle-btn" [class.off]="!filter.showVendoringRares"
      (click)="toggleShowVendoringRares()"></button>
  </span>
  <span class="filter-body">
    <span filter-title text="{{ isMobile() ? 'Vendoring Rares' : poe2 ? 'Rares to Disenchant or sell' : 'Vendoring Items' }}" ruleId="gear-hidden-vendoring-rares">
      @if (poe1) {
        Shows <span class="magic-item-color">Magic</span> and/or <span class="rare-item-color">Rare</span> Gear which can be vendored at an NPC for 5x (rare) or 2x (magic) <span class="currency-color">Transmutation Shard</span>s (unidentified) or <span class="currency-color">Alteration Shard</span>s (identified, amount depending on mods).
      } @else {
        Shows <span class="magic-item-color">Magic</span> and/or <span class="rare-item-color">Rare</span> Gear which can be sold at an NPC vendor for <span class="currency-color">Gold</span>, or Disenchanted.
        <br /><br /><span class="rare-item-color">Rare</span> items are Disenchanted into 1 (or 2, for 6 mods) <span class="currency-color">Regal Shard</span>. <span class="magic-item-color">Magic</span> items are Disenchanted into 1 <span class="currency-color">Transmutation Shard</span>.
      }
    </span>
    <span class="sep"></span>
    <app-select-gear-size
      [allowedSizes]="[GearSizeType.All, GearSizeType.MediumOnly, GearSizeType.TwoByTwoOnly]"
      [disabled]="!filter.showVendoringRares"
      [(ngModel)]="filter.showVendoringRaresSize"
      (selectedValueChange)="updateFilter()"></app-select-gear-size>
    @if (includeMagics) {
      <span class="sep"></span>
      <app-filter-checkbox-group
        [filter]="filter"
        filterPropertyName="showVendoringMagics"
        labelText="Magic"></app-filter-checkbox-group>
      <span class="sep"></span>
      <app-select-gear-size
        [allowedSizes]="[GearSizeType.All, GearSizeType.MediumOnly, GearSizeType.TwoByTwoOnly]"
        [disabled]="!filter.showVendoringMagics"
        [(ngModel)]="filter.showVendoringMagicsSize"
        (selectedValueChange)="updateFilter()"></app-select-gear-size>
    }
    <span class="sep"></span>
    <button class="btn toggle-button show-filters-button" [class.active]="showVendoringItemsFilters" [disabled]="!filter.showVendoringRares"
      (click)="showVendoringItemsFilters = !showVendoringItemsFilters">
      <span class="icon icon-equalizer"></span>
    </button>
  </span>
</div>

@if (showVendoringItemsFilters) {
  <div class="filter filter-property filter-padded-left" style="width: 100%;">
    <span class="filter-body">
      <span class="filter-title" [class.disabled]="!filter.showVendoringRares">Until Area Level</span>
      <span class="sep"></span>
      <div class="filter-title filter-label" [class.disabled]="!filter.showVendoringRares">Rares</div>
      <span class="sep"></span>
      <input type="number" placeholder="40" min="1" max="100" inputmode="numeric" class="form-control minmax" style="min-width: 50px; width: 50px;"
        [disabled]="!filter.showVendoringRares" [(ngModel)]="filter.showVendoringRaresUntilAreaLevel" (change)="updateFilter()">
      @if (includeMagics) {
        <span class="sep"></span>
        <div class="filter-title filter-label" [class.disabled]="!filter.showVendoringMagics">Magics</div>
        <span class="sep"></span>
        <input type="number" placeholder="20" min="1" max="100" inputmode="numeric" class="form-control minmax" style="min-width: 50px; width: 50px;"
          [disabled]="!filter.showVendoringMagics" [(ngModel)]="filter.showVendoringMagicsUntilAreaLevel" (change)="updateFilter()">
      }
    </span>
  </div>
  <div class="filter filter-property filter-padded-left" style="width: 100%;">
    <span class="filter-body">
      <span filter-title text="Display Style" [additionalContent]="showVendoringRaresAdditionalContent">
        <ng-template #showVendoringRaresAdditionalContent>
          @if (filter.showVendoringRaresType === VendoringGearType.ShowStyled) {
            <app-custom-rule-style-picker
              [filter]="filter"
              [ruleId]="'gear-hidden-vendoring-rares'"
              [active]="true"
              [defaultVisible]="true"
              [exampleName]="'Crude Bow'"
              [rarity]="Rarity.Rare"
              [title]="'Vendoring Rare Items'"></app-custom-rule-style-picker>
          } @else if (filter.showVendoringRaresType === VendoringGearType.ShowNormalHighlightLevelingRares) {
            <app-equipment-tier-picker
              [equipmentType]="EquipmentType.OtherGearLevelingRaresStyle"
              [active]="true"
              [exampleName]="'Leveling Gear'"
              [rarity]="Rarity.Rare"></app-equipment-tier-picker>
          }
          @if (includeMagics && filter.showVendoringRaresType === VendoringGearType.ShowStyled) {
            <app-custom-rule-style-picker
              [filter]="filter"
              [ruleId]="'gear-hidden-vendoring-magic'"
              [active]="true"
              [defaultVisible]="true"
              [exampleName]="'Crude Bow'"
              [rarity]="Rarity.Magic"
              [title]="'Vendoring Magic Items'"></app-custom-rule-style-picker>
          } @else if (includeMagics && filter.showVendoringRaresType === VendoringGearType.ShowNormalHighlightLevelingRares) {
            <app-equipment-tier-picker
              [equipmentType]="EquipmentType.OtherGearLevelingRaresStyle"
              [active]="true"
              [exampleName]="'Leveling Gear'"
              [rarity]="Rarity.Magic"></app-equipment-tier-picker>
          }
        </ng-template>
      </span>
      <span class="sep"></span>
      <app-select [disabled]="!filter.showVendoringRares" [(ngModel)]="filter.showVendoringRaresType" (selectedValueChange)="updateFilter()">
        <app-option [value]="VendoringGearType.PreventTransparentHidden" text="Holding Alt Key"></app-option>
        <app-option [value]="VendoringGearType.ShowDefault" text="Default"></app-option>
        <app-option [value]="VendoringGearType.ShowStyled" text="Styled"></app-option>
        <app-option [value]="VendoringGearType.ShowTransparent" text="Small & Transparent"></app-option>
        <app-option [value]="VendoringGearType.ShowNormalHighlightLevelingRares" text="Highlight Leveling Rares"></app-option>
      </app-select>
    </span>
  </div>
}

